import React, { useEffect, useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { API_BASE_URL } from "../../../utils/config";
import CompanyStoreSelector from "../../shared/CompanyStoreSelector";
import { setSidebarScope } from "../../../redux/slices/scopeFilterSlice";

// "All Companies · All Stores" filter shown at the top of the (expanded)
// sidebar on the admin side. Picking here applies to EVERY page's Company/
// Store filter (see redux/slices/scopeFilterSlice.js); a page's own filter
// then only changes that page. The list opens right under the pill with the
// sidebar's own width (CompanyStoreSelector fitAnchor).

let cache = { token: null, companies: [], stores: [] };

export default function SideNavScopeFilter() {
  const dispatch = useDispatch();
  const token = useSelector((s) => s.auth.token);
  const storeIds = useSelector((s) => s.scopeFilter.global.storeIds);
  const [data, setData] = useState(cache.token === token ? cache : { companies: [], stores: [] });

  useEffect(() => {
    if (!token) return undefined;
    if (cache.token === token) { setData(cache); return undefined; }
    let alive = true;
    axios
      .get(`${API_BASE_URL}/api/sellvia/store-names`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data: res }) => {
        const list = res.companies || [];
        const companies = list
          .map((c) => ({ _id: String(c.company_id), name: c.company_name || "Company", storeCount: (c.stores || []).length }))
          .sort((a, b) => a.name.localeCompare(b.name));
        const stores = list.flatMap((c) => (c.stores || []).map((st) => ({ ...st, sellvia_dashboard_id: String(c.company_id) })));
        cache = { token, companies, stores };
        if (alive) setData(cache);
      })
      .catch((err) => console.warn("[SideNavScopeFilter] could not load companies/stores:", err?.message));
    return () => { alive = false; };
  }, [token]);

  const selected = useMemo(() => (storeIds === null ? null : [...storeIds]), [storeIds]);

  // Nothing to filter with a single store (or while loading).
  if (data.stores.length < 2) return null;

  return (
    <Box sx={{ px: "12px", pt: "12px", pb: "4px" }}>
      <Typography sx={{ fontSize: "0.62rem", fontWeight: 800, letterSpacing: "0.08em", textTransform: "uppercase", color: "#7d7466", mb: 0.7, px: 0.5 }}>
        Company &amp; Store
      </Typography>
      <CompanyStoreSelector
        fitAnchor
        companies={data.companies}
        stores={data.stores}
        selectedStoreIds={selected}
        onChange={(sel) => dispatch(setSidebarScope(sel))}
      />
    </Box>
  );
}
